import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { HubletOption } from 'signup-constants/signupData/HubletOption';

const checkAuth = (hublet = HubletOption.na1) => {
  return noPortalApiClient.get(`${getFullUrl('app-api', {
    hubletOverride: hublet
  })}/users/v2/app/users/plus-hub-ids/hubless`, {
    ignoreRedirect: true
  });
};

export default checkAuth;